/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { entity } from '@gh/core-data';
import { AverageContractPriceDto } from '../dto';

export const AverageContractPriceMapper = entity<AverageContractPriceDto>({});
